import { crmSearchAndOpenRecords } from './crmApi';

export const searchAndOpenRecords = async (type: string, caseid: string, query?: string) => {
  const queryString = query ?? `?$select=${type}id&$filter=${type}id eq '${caseid}'`;
  try {
    await crmSearchAndOpenRecords(type, queryString, false);
  } catch (error) {
    const errorMsg = `searchAndOpenRecords error: type:${type}, caseId${caseid}, query:${queryString} `;
    console.log(errorMsg);
    throw new Error(errorMsg);
  }
};
